import { render, staticRenderFns } from "./Vehs.vue?vue&type=template&id=48fbb342"
import script from "./Vehs.vue?vue&type=script&lang=js"
export * from "./Vehs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports